import { Globe, Instagram, Linkedin, Youtube } from 'lucide-react';
import { LinktreeIcon, TikTokIcon } from '@/lib/wsjSocialIcons';

/** Links oficiais WSJ — usados no footer global. */
export const wsjSocialLinks = [
  {
    label: 'Site WSJ Soluções Digitais',
    url: 'https://www.wsjsolucoesdigitais.com/',
    Icon: Globe
  },
  {
    label: 'Linktree WSJ',
    url: 'https://linktr.ee/wsjsolucaodigital',
    Icon: LinktreeIcon
  },
  {
    label: 'Instagram WSJ',
    url: 'https://www.instagram.com/wsjsolucaodigital',
    Icon: Instagram
  },
  {
    label: 'TikTok WSJ',
    url: 'https://www.tiktok.com/@wsjsolucaodigital',
    Icon: TikTokIcon
  },
  {
    label: 'LinkedIn WSJ',
    url: 'https://www.linkedin.com/in/wsj-solu%C3%A7%C3%B5es-digitais-6bb626178/',
    Icon: Linkedin
  },
  {
    label: 'YouTube WSJ',
    url: 'https://www.youtube.com/@WSJSolu%C3%A7%C3%B5esDigitais',
    Icon: Youtube
  }
];
